module.exports = __webpack_public_path__ + "img/midia-malls.e5399a62.svg";